// extracted by css-extract-rspack-plugin
export default {"root":"_5Z5y2","variant-horizontal":"buqN81","variantHorizontal":"buqN81","title":"YmWioE","message":"TqmjCT","core-star":"TeMMOQ","coreStar":"TeMMOQ"};